import { useMutation } from '@tanstack/react-query';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

export const useOnboardWithFuse = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId } = useBackoffice();

  const mutation = useMutation({
    mutationKey: ['onboard-customer-with-fuse'],
    mutationFn: async ({ customerId }: { customerId: string }) => {
      const token = await getAccessTokenSilently();
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}/fuse/onboard`,
        null,
        {
          params: {
            consumerId: developerId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data?.data;
    },
  });

  return mutation;
};
